'use client';

import HeadlineField, { HeadlineTag } from '@/storyblok/wirfuersklima/functionalComponents/HeadlineField';
import ContentSection from '@/storyblok/wirfuersklima/functionalComponents/contentSection/ContentSection';
import TeaserBox from '@/storyblok/wirfuersklima/partials/teaserBox/TeaserBox';
import type { SectionTeaserStoryblok } from '@/storyblok/wirfuersklima/types';
import dynamic from 'next/dynamic';
import { useInView } from 'react-intersection-observer';
import { render } from 'storyblok-rich-text-react-renderer';

import classes from './SectionTeaser.module.scss';

const LottieAnimation = dynamic(() =>
  import('@/storyblok/wirfuersklima/functionalComponents/LottieAnimation').then((mod) => mod.LottieAnimation)
);

const SectionTeaser: React.FC<{ blok: SectionTeaserStoryblok }> = ({ blok }) => {
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: '200px 0px' });
  const frameCount = Number(blok.animation_frames);
  return (
    <ContentSection blok={blok} className={classes['section-teaser']} anchorId={blok.anchor_id}>
      <div ref={ref} className={classes['section-teaser__animation']}>
        {inView && <LottieAnimation path={blok.animation.filename || undefined} frames={frameCount} style={{}} />}
      </div>
      <div className="grid-wrapper">
        <div className={classes['section-teaser__text']}>
          <HeadlineField tag={HeadlineTag.H2} style={HeadlineTag.H2} className={classes['section-teaser__title']}>
            {blok.headline}
          </HeadlineField>
          {blok.text != null && render(blok.text)}
        </div>
        <div className={classes['section-teaser__box-wrapper']}>
          {blok.teaser?.map((listItem) => (
            <TeaserBox key={listItem._uid} blok={listItem} />
          ))}
        </div>
      </div>
    </ContentSection>
  );
};

export default SectionTeaser;
